/**
 * Client env — Vite exposes only `VITE_`-prefixed variables to the browser
 * via `import.meta.env`.
 */
import { z } from "zod";

const envSchema = z.object({
  /** Public URL of apps/server. Example: http://localhost:3000 (dev), https://api.gately.geerd.ma (prod). */
  VITE_SERVER_URL: z.string().url(),
  // Bare digits, no "+", e.g. "212600000000". Used as https://wa.me/<digits>
  // on the org-suspended screen. Optional so dev builds don't break.
  VITE_SUPPORT_WHATSAPP: z.string().optional(),
  // Sentry (error/perf tracking). Absent = disabled. EU-region DSN for GDPR.
  VITE_SENTRY_DSN: z.string().url().optional(),
  // Sentry environment (production/staging/development). Falls back to Vite's
  // build MODE when unset. Set per build so environments separate in Sentry.
  VITE_SENTRY_ENVIRONMENT: z.string().optional(),
  // PostHog (product analytics + session replay). Absent = disabled.
  VITE_POSTHOG_KEY: z.string().optional(),
  VITE_POSTHOG_HOST: z.string().url().optional(),
  // Cloudflare Turnstile site key for the /support form. Optional so dev
  // builds work without it (form submits a placeholder token).
  VITE_TURNSTILE_SITE_KEY: z.string().optional(),
  // Public docs site (apps/docs). Target of the sidebar "Documentation"
  // shortcut. Defaulted rather than optional so the link always resolves —
  // override per environment to point at a staging docs deploy.
  VITE_DOCS_URL: z.string().url().default("https://docs.gately.ma"),
});

export const env = envSchema.parse(import.meta.env);
